const handleVerifyMobileNumber = (_mobileNumber: string): boolean => {
  const mobileNumber = _mobileNumber.replace(/\s/g, '');
  if (!mobileNumber || mobileNumber.trim().length < 10 || mobileNumber.trim().length > 10 || mobileNumber[0] !== '0' || !Number(mobileNumber)) return false;
  return true;
};

export default handleVerifyMobileNumber;
